import React, { useEffect } from 'react';
import Logo from "../../assets/logo.svg";
import Logotext from "../../assets/logoText.svg";
import WhiteArrow from "../../assets/backArrow.svg";
import "../login/login.scss";
import { useNavigate, useParams } from 'react-router-dom';
import { useLazyVerifyMagicLickQuery } from '../../service/apiSlices/authSlice';
import { clearSessionStorage, SetSessionStorageData } from '../../utilities/helper';
import LoginInnerContent from '../../components/loginForm/loginInnerCard';
import { ROUTES, TOKENS } from '../../utilities/Constants/Constants';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../utilities/toastUtils';

const VerifyLogin: React.FC = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const { token } = useParams();
    const [verifyMagicLick] = useLazyVerifyMagicLickQuery();

    useEffect(() => {
        if (token) {
            verifyMagicLick(token)
                .unwrap()
                .then((response: any) => {
                    if (response?.status_code === 200) {
                        SetSessionStorageData(
                            TOKENS.ACCESS_TOKEN,
                            response.access_token
                        );
                        sessionStorage.setItem("new_user", response?.new_user);
                        showSuccessToast(response.message);
                        navigate(ROUTES.DASHBOARD);
                    }
                })
                .catch((error) => {
                    console.error('API Error:', error);
                    showErrorToast('Failed to verify magic link');
                    navigate(ROUTES.LOGIN);
                });
        } else {
            navigate(ROUTES.LOGIN);
            clearSessionStorage();
        }
    }, [navigate, token, verifyMagicLick])

    return (
        <div className="container-fluid clientAdmin">
            <div className="row g-2">
                <div className="col-md-8">
                    <div className="bg-image-primary">
                        <LoginInnerContent />
                    </div>
                </div>
                <div className="col-md-4 relative col-12 d-flex align-items-center justify-content-center flex-column bg-dark text-white rounded-20 bg-image-secondary">
                    <div className='d-flex align-items-center absolute backArrowSection gap-2 cursor-pointer'>
                        <img src={WhiteArrow} alt='WhiteArrow' className='' onClick={() => navigate(ROUTES.LOGIN)} />
                        <p className='interFont fw-bold backtext mb-0'>{t('buttons.back')}</p>
                    </div>
                    <form className="form-container ps-4">
                        <div className='d-flex align-items-center gap-2'>
                            <img src={Logo} alt='logo' className='' />
                            <img src={Logotext} alt='Logotext' className='' />
                        </div>
                        <p className='magiclinktext fw-bold interFont mt-4'>{t("login.success")}</p>
                        <p className='interFont magiclinkDes fst-italic fw-normal'>{t("login.subContent")}</p>
                    </form>

                </div>
            </div>
        </div>
    )
};

export default VerifyLogin;
